import Abstract from "../../../abstract-view/abstract.js";

export default class SortingButton extends Abstract {
  constructor(element, index) {
    super();

    this._element = element;
    this._index = index;

    this._textElement = null;
    this._sortName = null;

    this._handleClick = this._handleClick.bind(this);
  }

  getTextElement() {
    if (!this._textElement) {
      this._textElement = this._element.querySelector(`span`);
    }

    return this._textElement;
  }

  isActive() {
    return this._element.classList.contains(`${this._element.classList[0]}_active`);
  }

  activate() {
    this._element.classList.add(`${this._element.classList[0]}_active`);
    this.getTextElement().classList.add(`${this.getTextElement().classList[0]}_active`);
  }

  setLoading() {
    this._element.classList.add(`${this._element.classList[0]}_loading`);
  }

  setLoaded() {
    this._element.classList.remove(`${this._element.classList[0]}_loading`);
  }

  isLoading() {
    return this._element.classList.contains(`${this._element.classList[0]}_loading`);
  }

  reset() {
    this._element.classList.remove(`${this._element.classList[0]}_active`);
    this.getTextElement().classList.remove(`${this.getTextElement().classList[0]}_active`);
  }

  getSortName() {
    if (!this._sortName) {
      this._sortName = this._element.dataset.sortName;
    }

    return this._sortName || ``;
  }

  getSortDir() {
    return this._element.dataset.sortDir;
  }

  setSortDir(value, oldValue) {
    this._element.dataset.sortDir = value;
    this._element.classList.remove(`${this._element.classList[0]}_${oldValue}`);
    this._element.classList.add(`${this._element.classList[0]}_${value}`);
  }

  setClickHandler(callback) {
    this._callback.click = callback;
    this._element.addEventListener(`click`, this._handleClick);
  }

  _handleClick(evt) {
    this._callback.click(evt, this._index);
  }
}
